__turbopack_context__.v({
  "currentLink": "NavQuickLinkPillItem-module-scss-module__s6pJKW__currentLink",
  "iconWrapper": "NavQuickLinkPillItem-module-scss-module__s6pJKW__iconWrapper",
  "img": "NavQuickLinkPillItem-module-scss-module__s6pJKW__img",
  "imgBox": "NavQuickLinkPillItem-module-scss-module__s6pJKW__imgBox",
  "label": "NavQuickLinkPillItem-module-scss-module__s6pJKW__label",
  "rectangle": "NavQuickLinkPillItem-module-scss-module__s6pJKW__rectangle",
  "wrapper": "NavQuickLinkPillItem-module-scss-module__s6pJKW__wrapper",
});
